// extracted by mini-css-extract-plugin
export default {"container":"UserEarningsField_container__bSIg-","title":"UserEarningsField_title__tTcLF","value":"UserEarningsField_value__I6+IS"};